import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition } from "@mcurros2/microm";

const columns = () =>
(
    {
        c_proceso_id: new EntityColumn<string>({ name: 'c_proceso_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Proceso Id' }),
        c_fileprocess_id: new EntityColumn<string>({ name: 'c_fileprocess_id', type: 'char', length: 20, flags: c.FK, prompt: 'Fileprocess Id' }),
        vc_errores: new EntityColumn<string>({ name: 'vc_errores', type: 'varchar', length: 0, flags: EntityColumnFlags.nullable, prompt: 'Errores' }),
        vc_fileguid: new EntityColumn<string>({ name: 'vc_fileguid', type: 'varchar', length: 255, flags: EntityColumnFlags.None, prompt: 'Fileguid' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        srip_brwStandard: { name: 'srip_brwStandard', keyMappings: { c_proceso_id: 0 } },
    }
)

export class SolicitudesRuteoImportacionProcesoDef extends EntityDefinition {

    columns = columns();
    views = views();

    constructor() {
        super('SolicitudesRuteoImportacionProceso');
    }
}